"use strict";

exports.__esModule = true;
exports.default = void 0;
var _cookie = require("@tajawal/web-core-sdk-v2/lib/services/cookie.service");
var _auth = require("../clients/auth.client");
var _constants = require("../constants");
var _auth2 = require("../utils/auth.utils");
const authInterceptor = {
  /**
   * request auth interceptor
   *
   * @param {object} _config [request config]
   * @return {object} config [request config]
   */
  async request(_config) {
    let config = _config;
    let newToken = null;
    if (!config.url.includes(_constants.ENDPOINTS.LOGIN) && _auth2.refreshToken.isGettingRefreshToken) {
      await _auth2.refreshToken.waitForRefreshToken();
    }
    if (config.url.includes(_constants.ENDPOINTS.ME)) {
      const expires_in_cookie = _cookie.$cookie.get(_constants.STORAGE_KEYS.TOKEN_EXPIRY);
      if (expires_in_cookie) {
        let expires_in = parseInt(expires_in_cookie, 10);
        expires_in -= Date.now();
        if (expires_in <= _constants.REFRESH_EXPIRY_TIMER) {
          const response = await _auth.AuthClient.refreshToken();
          if (response && response.access_token) {
            newToken = response.access_token;
          }
        }
      }
    }
    if (config.url.includes('/myaccount/')) {
      const apiToken = _cookie.$cookie.get(_constants.STORAGE_KEYS.ENIGMA_API_TOKEN);
      config = apiToken ? {
        ...config,
        headers: {
          ...config.headers,
          'x-authorization': config.url.includes('payment-instruments') ? `Bearer ${apiToken}` : `${apiToken}`
        }
      } : config;
    }
    const token = _cookie.$cookie.get(_constants.STORAGE_KEYS.AUTH_TOKEN);
    return token ? {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`
      }
    } : config;
  },
  /**
   * response auth interceptor
   *
   * @param {object} error [request config]
   * @return {object} error
   */

  responseError(error) {
    if (_auth2.refreshToken.isGettingRefreshToken || !error || !error.response || error && error.response && error.response.config && error.response.config.url.includes(_constants.ENDPOINTS.LOGIN)) {
      return error;
    }
    const UnAuthorized = error.response.status === 401;
    if (UnAuthorized) {
      const token = _cookie.$cookie.get(_constants.STORAGE_KEYS.AUTH_TOKEN);
      if (token) {
        _auth.AuthClient.refreshToken(false, true);
      }
    }
    return error;
  }
};
var _default = authInterceptor;
exports.default = _default;